import React from 'react';
import {
  Card,
  CardActions,
  CardTitle,
  CardText,
  Chip,
  TextField,
  FlatButton,
  RaisedButton,
} from 'material-ui';
import { translate as t, ViewTitle } from 'admin-on-rest';
import moment from 'moment';

import Refresh from 'material-ui/svg-icons/navigation/refresh';

import References from './References';
import RichTextField from './fields/RichTextField';
import { isSuperUser } from '../utils/../utils/permissionsUtils';
import { regscape } from '../utils/StringUtils';

const NewsComponent = ({
  choices: { news, venues },
  user,
  queryFilter,
  positionFilter,
  onToggleReadMore,
  readMore,
  translate,
}) => {
  const areas = venues ? venues.map((venue) => venue.area).filter((item) => !!item) : [];
  const markets = venues ? venues.map((venue) => (venue.market ? venue.market._id : '')) : [];

  // filter by permissions (job positions)
  if (!news) return null;
  let newsItems = news.filter((newsItem) => {
    if (user && user.superUser) {
      return true;
    }
    const permissions = positionFilter.map((position) =>
      newsItem.positions.length > 0 ? newsItem.positions.includes(position) : true
    );
    return permissions.includes(true);
  });

  // filter by market
  newsItems = newsItems.filter((newsItem) => {
    if (isSuperUser(user)) {
      return true;
    }
    if (newsItem.markets.length > 0) {
      if (markets.some((market) => newsItem.markets.includes(market))) {
        return true;
      }
      return false;
    }
    return true;
  });

  // filter by area manager areas
  newsItems = newsItems.filter((newsItem) => {
    if (isSuperUser(user)) {
      return true;
    }
    if (newsItem.areas.length > 0) {
      if (areas.some((area) => newsItem.areas.includes(area))) {
        return true;
      }
      return false;
    }
    return true;
  });

  // filter by search query
  newsItems = newsItems.filter((filteredNews) => {
    if (!queryFilter) {
      return true;
    }
    const filteredTags = filteredNews.tags.map((tag) => {
      const matchesTag = new RegExp( // build new Regular Expression instance
        regscape(queryFilter), // our search string
        'gi' // search [g]lobally and case [i]sensitive
      ).test(tag); // test this RegExp against our book title, returns boolean)
      return matchesTag;
    });
    return filteredTags.includes(true);
  });
  // updatedAt and createdAt date formatting
  const dateFormat = 'D/MM YYYY HH:mm:ss';
  // map into cards
  newsItems = newsItems.map(({ id, title, body, tags, updatedAt, createdAt }) => {
    // format the dates to be readable
    const created = moment(createdAt).format(dateFormat);
    const updated = moment(updatedAt).format(dateFormat);
    // check if body without any whitespace is long enough to show a Read More button
    const showReadMore =
      !readMore.includes(id) &&
      body &&
      body.replace(/[^A-z0-9]/g, '').length >
        (body.indexOf('<img') === -1 && body.indexOf('www.youtube.com/embed') === -1 ? 1200 : 200);

    return (
      <Card
        style={{ marginTop: '5px', position: 'relative', paddingTop: tags.length ? '10px' : '' }}
        key={id}
      >
        <CardTitle
          title={title}
          subtitle={
            <span
              style={{
                position: 'relative',
                fontWeight: 'normal',
                color: 'rgba(0,0,0,0.5)',
                fontSize: '12px',
              }}
            >
              <span>
                {translate('created')} {created}
              </span>
              {created !== updated && (
                <span>
                  {' '}
                  {translate('and')} {translate('edited')} {updated}
                </span>
              )}
              <div>
                {tags.map((tag) => (
                  <Chip
                    key={`${tag}`}
                    labelStyle={{
                      fontSize: '10px',
                      paddingLeft: '8px',
                      paddingRight: '8px',
                      lineHeight: '17px',
                    }}
                    style={{
                      display: 'inline-block',
                      margin: '5px 5px 0 0',
                      border: '1px solid rgba(0, 0, 0, 0.24)',
                      background: 'transparent',
                    }}
                  >
                    {tag}
                  </Chip>
                ))}
              </div>
            </span>
          }
          style={{ paddingBottom: 0, fontSize: '20px', fontWeight: 'bold' }}
        />
        <CardText className="news-viewer-item-container">
          {showReadMore ? (
            <div className="read-more-block">
              <RichTextField content={body} />
            </div>
          ) : (
            <RichTextField content={body} />
          )}
        </CardText>
        {showReadMore && (
          <div className="blocker">
            <RaisedButton
              onClick={() => onToggleReadMore(id)}
              primary
              label={translate('readMore')}
            />
          </div>
        )}
      </Card>
    );
  });

  return <div>{newsItems}</div>;
};

class News extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: '',
      positions: [],
      readMore: [],
      fromDate: moment()
        .subtract(30, 'days')
        .toDate(),
    };
  }

  componentWillMount = () => {
    this.getPositions(this.props.permissions);
  };

  getPositions = (permissions) => {
    const permissionArr = [];

    if (this.props.user && !this.props.user.superUser) {
      Object.keys(permissions).forEach((key) =>
        permissions[key].position.forEach(
          (permission) => permissionArr.indexOf(permission) === -1 && permissionArr.push(permission)
        )
      );
    }
    this.setState({ positions: permissionArr });
  };

  setFromDate = () =>
    this.setState(({ fromDate }) => ({
      fromDate: moment(fromDate)
        .subtract(30, 'days')
        .toDate(),
    }));

  handleTextInputChange = (e) => {
    const { value } = e.target;
    this.setState({ filter: value });
  };

  forceUpdate = () => {
    this.setState({ ...this.state });
  };

  toggleReadMore = (id) =>
    this.setState((state) => ({
      readMore: state.readMore.includes(id)
        ? state.readMore.filter((rM) => rM !== id)
        : [...state.readMore, id],
    }));

  render() {
    const { props } = this;
    const { translate, locale } = this.props;
    const { filter, positions, readMore, fromDate } = this.state;

    if (!props.user) {
      return null;
    }

    return (
      <Card>
        <CardActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <FlatButton primary label="Refresh" onClick={this.forceUpdate} icon={<Refresh />} />
        </CardActions>
        <ViewTitle title={translate('news.news')} />
        <div style={{ padding: '15px' }}>
          <TextField
            hintText={translate('search', { queryables: translate('tag') })}
            onChange={(e) => this.handleTextInputChange(e)}
            fullWidth
          />
          <References
            references={[
              { name: 'news', filter: { language: ['en', 'sv'].includes(locale) ? locale : 'en', createdAt: { $gt: fromDate } } },
              { name: 'venues', filter: { name: { $in: props.user && !props.user.superUser ? props.user.venues : [] } } },
            ]}
            {...props}
          >
            <NewsComponent
              readMore={readMore}
              onToggleReadMore={this.toggleReadMore}
              positionFilter={positions}
              queryFilter={filter}
              {...props}
            />
          </References>
        </div>
        <div style={{ textAlign: 'center' }}>
          <FlatButton primary label={translate('news.load-older')} onClick={this.setFromDate} />
        </div>
      </Card>
    );
  }
}

News.defaultProps = {
  permissions: {},
  user: {},
};

// const selector = getFormValues('record-form');

// export default connect(
//   (state) => ({
//     record: selector(state),
//     user: get(state, 'auth.user'),
//     permissions: get(state, 'auth.user.permissions'),
//   }),
//   {}
// )(withRouter(t(News)));

export default t((props) => (
  <Card>
    <CardText>
      <h1>{props.translate('news-moved-title')}</h1>{' '}
      <p style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
        <a href="https://pinchonation.workplace.com/">
          {props.translate('news-moved-text')}
        </a>
      </p>
    </CardText>
  </Card>
));
